// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"M4-z"};